class Toolbarmobile extends HTMLElement {
  constructor() {
    super();

    this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    this.handleViewportChange = this.updateVisibility.bind(this);
    this.handleResize = theme.utils.rafThrottle(this.updateHeight.bind(this));
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.sectionObserver = new MutationObserver(this.handleViewportChange);
  }

  connectedCallback() {
    if (this.mobileMediaQuery.addEventListener) {
      this.mobileMediaQuery.addEventListener('change', this.handleViewportChange);
    } else {
      this.mobileMediaQuery.addListener(this.handleViewportChange);
    }
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.resizeObserver.observe(this);
    this.sectionWrapper = this.closest('.shopify-section');
    if (this.sectionWrapper) {
      this.sectionObserver.observe(this.sectionWrapper, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    this.updateVisibility();
  }

  disconnectedCallback() {
    if (this.mobileMediaQuery.removeEventListener) {
      this.mobileMediaQuery.removeEventListener('change', this.handleViewportChange);
    } else {
      this.mobileMediaQuery.removeListener(this.handleViewportChange);
    }
    window.removeEventListener('resize', this.handleResize);
    this.resizeObserver.disconnect();
    this.sectionObserver.disconnect();

    if (!document.querySelector('toolbar-mobile.active')) {
      document.body.style.removeProperty('--toolbar-mobile-height');
    }
  }

  updateVisibility() {
    const sectionIsHidden = this.sectionWrapper?.classList.contains('shopify-section-hidden') || this.sectionWrapper?.hasAttribute('hidden');
    const shouldShow = this.mobileMediaQuery.matches && !sectionIsHidden;

    this.classList.toggle('active', shouldShow);
    this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

    if (shouldShow) {
      this.updateHeight();
    } else if (!document.querySelector('toolbar-mobile.active')) {
      document.body.style.removeProperty('--toolbar-mobile-height');
    }
  }

  updateHeight() {
    if (!this.classList.contains('active')) return;

    const height = Math.ceil(this.getBoundingClientRect().height);
    if (height > 0) {
      document.body.style.setProperty('--toolbar-mobile-height', `${height}px`);
    }
  }
}

if (!customElements.get('toolbar-mobile')) {
  customElements.define('toolbar-mobile', Toolbarmobile);
}
